import React, { FC, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Input,
  Button,
  Modal,
  Row,
  Col,
  DatePicker,
  TimePicker,
  Checkbox,
  Radio,
  Switch,
  Collapse,
  Select,
} from "antd";
import { SearchOutlined, DownOutlined } from "@ant-design/icons";
import _ from "lodash";
import Icon from "@ant-design/icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Reorder from "./Reorder";
import moment from "moment";
import {getMembersPageListPath, } from "../../helpers/request/RequestPath"
import {getItemListRequestPayload, getPageSearchArgument, wrapRequestPayload} from '../../helpers/request/RequestPayload'
import {SocketTopics} from "../../constants/enums"
import {
  getPagesRequestPublishTopic,
} from "hooks/MQTTConstants";
import useLocalStorageService from "../../services/localStorage";
import { useSelector } from "react-redux";
import { GET_USERS_LIST } from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";

import { useDispatch } from "react-redux";


const { Panel } = Collapse;
const { Option } = Select; 

const getDefaultFilter = () => {
  return {
    readStatus: [],
    pageType: "all",
    userStatus: undefined,
    pageStatus: undefined,
    liveIoT: ["Gps"],
    owner: "",
    createdAt: "",
    deleted: false,
    sort: "",
    order: "ASC",
  }
};

enum StatusColor {
  Green="green",
  Amber="amber",
  Red="red",
  Blue="blue",
  Purple="purple",
  Grey="grey"
}

const colorMap = {
  Green: 'green-radio',
  Amber: 'yellow-radio',
  Red: 'orange-radio',
  Blue: 'blue-radio',
  Purple: 'pink-radio',
  Grey: 'gray-radio'
}

const FilterByModal: FC<{
  isModalVisible: boolean;
  setIsModalVisible: (isModalVisible: boolean) => void;
  socket: ISocket
}> = ({ isModalVisible, setIsModalVisible, socket }) => {
  const [filters, setFilters] = useState<Filters>(getDefaultFilter());

  const {getLocalStorageItem, setLocalStorageItem} = useLocalStorageService();
  const { users } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();


  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    setLocalStorageItem('filter', filters);
    dispatch({type: 'SEARCH_PAGE', payload: {paginate: false, reset: true}})
    setIsModalVisible(false);
  };

  useEffect(() => {
    const filter = getLocalStorageItem('filter');
    if(filter){
      setFilters(JSON.parse(filter))
    }
  }, []);


  const updateFilter = (key: keyof Filters, value: ValueOf<Filters>) => {
    setFilters((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const {
    readStatus,
    pageType,
    pageStatus,
    userStatus,
    liveIoT,
    owner,
    createdAt,
    deleted,
    order,
    sort
  } = filters;

  return (
    <Modal
      title="Filter By"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="450px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Row className="d-flex pl-2">
        <Col span="9">
          <h5>Read Status</h5>
        </Col>
        <Col>
          <Checkbox.Group
            onChange={(values: any)=>{
                updateFilter('readStatus', values);
            }}
            value={readStatus}
            options={["Read", "Unread"]}
            defaultValue={["Read"]}
          />
        </Col>
      </Row>
      <hr />
      <Row className="d-flex">
        <Col md={3} xs={5}>
          <Button onClick={()=>{updateFilter('pageType', 'all')}} className={`beam-btn ${pageType === 'all' ? 'green-btn cover': ''}`}>All</Button>
        </Col>
        <Col md={6} xs={9}>
          <Button onClick={()=>{updateFilter('pageType', 'regular')}} className={`beam-btn ${pageType === 'regular' ? 'green-btn cover': ''}`}>Regular</Button>
        </Col>
        <Col md={6} xs={9}>
          <Button onClick={()=>{updateFilter('pageType', 'friend')}}  className={`beam-btn ${pageType === 'friend' ? 'green-btn cover': ''}`}>Friends</Button>
        </Col>
        <Col md={6} xs={8}>
          <Button onClick={()=>{updateFilter('pageType', 'event')}}  className={`beam-btn ${pageType === 'event' ? 'green-btn cover': ''}`}>Incidents</Button>
        </Col>
      </Row>
      <hr />
      <Row className="pl-2">
        <Col span="5">
          <h5>
            User <br />
            status
          </h5>
        </Col>
        <Col span="19">
          <Radio.Group onChange={(e: any)=>{
            }} value={userStatus}>
              {Object.keys(StatusColor).map((color: any) => (
                   <Radio value={StatusColor[color]} className={colorMap[color]} onClick={(e: any)=>{
                    if(userStatus === e.target.value)
                      updateFilter('userStatus', undefined)
                    else  
                      updateFilter('userStatus', e.target.value)
                }}></Radio>
              ))}
          </Radio.Group>
        </Col>
      </Row>
      <hr />
      <Row className="pl-2">
        <Col span="5">
          <h5>
            Page <br />
            status
          </h5>
        </Col>
        <Col span="19">
        <Radio.Group onChange={(e: any)=>{
            }} value={pageStatus}>
              {Object.keys(StatusColor).map((color: any) => (
                   <Radio value={StatusColor[color]} className={colorMap[color]} onClick={(e: any)=>{
                    if(pageStatus === e.target.value)
                      updateFilter('pageStatus', undefined)
                    else  
                      updateFilter('pageStatus', e.target.value)
                }}></Radio>
              ))}
          </Radio.Group>
        </Col>
      </Row>
      <hr />
      <Row className="d-flex pl-2">
        <Col span="9">
          <h5>Live IoT</h5>
        </Col>
        <Col span="15">
          <Checkbox.Group
            onChange={(values: any)=>{
              updateFilter('liveIoT', values);
            }}
            value={liveIoT}
            options={["GPS", "Video"]}
            defaultValue={["GPS"]}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col span={24}>
          <Select
            placeholder="Please select owner"
            onChange={(value: any) => {
              updateFilter('owner', value);
            }}
            value={owner ? owner: undefined}
            maxTagCount={"responsive"}
            style={{ width: "100%" }}
            listHeight={100}
          >
            {users &&
              users.map((people, idx) => (
                <Option value={people.id} key={idx}>
                  {people.name}
                </Option>
              ))}
          </Select>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col span={24}>
          <div className="datetime-item">
            <img src="/images/date.png" />
            <DatePicker
              value={(createdAt && createdAt !== "") ? moment(createdAt): undefined}
              onChange={(time: moment.Moment | null) => {
                updateFilter("createdAt", time?.format("MM/DD/YYYY HH:mm:ss"));
              }}
              placeholder="Filter by date"
              suffixIcon={<DownOutlined />}
            />
          </div>
        </Col>
      </Row>
      <hr />
      <Row className="d-flex px-2">
        <Col span="7">
          <h5>Deleted</h5>
        </Col>
        <Col span="17">
          <Switch checked={deleted} onChange={(value: any)=>{updateFilter('deleted', value)}}/>
        </Col>
      </Row>
      <Row className="mt-3">
        <Collapse defaultActiveKey={["1"]} bordered={false}>
          <Panel header="Apps:" key="1">
            <Row className="d-flex">
              <Col>
                <Button className="beam-btn round-btn">
                  <img
                    src="/images/pause.png"
                    style={{ maxWidth: 40, maxHeight: 40 }}
                  />
                </Button>
              </Col>
              <Col>
                <Button className="beam-btn round-btn">
                  <img src="/images/user.png" />
                </Button>
              </Col>
              <Col>
                <Button className="beam-btn round-btn">
                  <img src="/images/net.png" />
                </Button>
              </Col>
              <Col>
                <Button className="beam-btn round-btn">
                  <img src="/images/car.png" />
                </Button>
              </Col>
              <Col>
                <Button className="beam-btn round-btn">
                  <img src="/images/iot_blue.png" />
                </Button>
              </Col>
              <Col>
                <Button className="beam-btn round-btn">
                  <img src="/images/Incident-icon.png" />
                </Button>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      </Row>
      <Row className="mt-3">
        <Col>
          <h3>Sort By</h3>
        </Col>
      </Row>
      <hr />
      <Reorder sort={sort} order={order} updateFilter={updateFilter}/>
      <Row className="action-grp mt-3">
        <Col span={12} className="pr-2">
          <Button
            className="beam-btn orange-btn bordered w-full"
            onClick={()=>{setFilters(getDefaultFilter())}}
          >
            Reset
          </Button>
        </Col>
        <Col span={12} className="pl-2">
          <Button
            className="beam-btn green-btn cover w-full"
            onClick={handleOk}
          >
            Save
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default FilterByModal;
